module.exports = __webpack_public_path__ + "static/media/5_shape_l.c54509ec.webp";